import { render, staticRenderFns } from "./InvoicePromotion.vue?vue&type=template&id=6d40c7a6&scoped=true&"
import script from "./InvoicePromotion.vue?vue&type=script&lang=js&"
export * from "./InvoicePromotion.vue?vue&type=script&lang=js&"
import style0 from "./InvoicePromotion.vue?vue&type=style&index=0&id=6d40c7a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d40c7a6",
  null
  
)

export default component.exports